module.exports = __webpack_public_path__ + "media/images/vp/icon.filter-a65a5ea3299b4f36a0acbc8481801899.svg";